import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { bootstrapThemeFromStorage } from '@core/theme/theme';
import { installChunkReload } from '@core/app-update/chunkReload';
import './index.css';
import App from './App';

bootstrapThemeFromStorage();
// A tab left open across a deploy reloads into the new build.
installChunkReload();

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
